import { useState, useEffect } from 'react';
import { getChatInfoByIds } from '../../network/TutorApiService';
import useStateRef from "react-usestateref";

const MAX_LIMIT = 10;
export const usePendingChatUpdater = (questionsData, setQuestionsData) => {
    const [pendingChatIds, setPendingChatIds] = useState([]);
    const [fetchCount, setFetchCount, fetchCountRef] = useStateRef(0);

    useEffect(() => {
        const extractedChatIds = questionsData
            .filter(item => item?.userAnswer?.chatId && item?.history[0]?.mode === "Descriptive Answer" &&
                item?.history?.[0]?.descriptive_answer?.evaluation_status === "pending")
            .map(item => item.userAnswer.chatId);
        setPendingChatIds(extractedChatIds);
    }, [questionsData]);

    useEffect(() => {
        let intervalId;
        console.log("fetch count -->" + fetchCountRef?.current)
        if (pendingChatIds.length > 0 && fetchCountRef?.current < MAX_LIMIT) {
            console.log('Pending chat ids:', pendingChatIds);
            intervalId = setInterval(() => {
                if (fetchCountRef?.current < MAX_LIMIT) {
                    fetchPendingChats(pendingChatIds);
                    setFetchCount(prevCount => prevCount + 1); // Increment fetch count
                } else {
                    clearInterval(intervalId); // Stop the interval after 10 fetches
                    console.log("Maximum fetch count reached, stopping the interval.");
                }
            }, 10000);
        } else {
            if (intervalId) {
                clearInterval(intervalId);
            }
            console.log("Maximum fetch count reached, stopping the interval.");
        }
        // Cleanup interval when pendingChatIds are empty or the effect is cleaned up
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [pendingChatIds]); // Only track pendingChatIds

    const fetchPendingChats = async (pendingChatIds) => {
        try {
            console.log('Fetching chat data for pending chat ids:', pendingChatIds);
            if (pendingChatIds.length > 0) {
                const chatData = await getChatInfoByIds(pendingChatIds);
                const updatedQuestionsData = questionsData.map((item) => {
                    if (item.userAnswer?.chatId && chatData[item.userAnswer.chatId]) {
                        const chatInfo = chatData[item.userAnswer.chatId];
                        return {
                            ...item,
                            history: chatInfo?.history || [],
                        };
                    }
                    return item;
                });
                setQuestionsData(updatedQuestionsData);
            }
        } catch (error) {
            console.error("Error fetching chat data:", error);
        }
    };
    return;
};
